(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .controller('RecomActionPlanUpdateStatusReviewController', Controller);

    Controller.$inject = ['$state', 'topBarService', 'bUnit', 'govProcess'];

    function Controller($state, topBarService, bUnit, govProcess) {

        var title = bUnit.TitleEN + ' Action Plans | Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        // Check for active gov process
        var isGovProcDisabled = !_.isObject(govProcess) || _.isUndefined(govProcess.GovernanceProcessID);
        if (!$state.is('recomActionPlanUpdateStatusReview.noActiveProcess') && isGovProcDisabled) {
            $state.go('recomActionPlanUpdateStatusReview.noActiveProcess', {}, { location: 'replace' });
            return;
        }

        // Go To First ActionPlan To Assess
        $state.go('recomActionPlanUpdateStatusReview.actionPlans', {}, { location: 'replace' });
    }
})();